import React from 'react';
import classes from './MySelect.module.css';

function MySelect({options, defaultValue, value, onChange}) {
    return ( 
        <select
            className={classes.mySelect}
            value={value}
            onChange={e => onChange(e.target.value)}
        >
          <option disabled value=''>{defaultValue}</option>
          {options.map(op => 
                <option key={op.value} value={op.value}>
                    {op.name}
                </option>
        )}
        </select>
     );
}

export default MySelect;